
<div
    [attr.id]="id ? (id + '_dialogOverlay') : null"
    class="agpr-dialogOverlay"
    [class.agpr-dialogOverlay--modal]="modal"
    [ngStyle]="{'z-index': zIndex}"
    role="presentation"
    (click)="closeDialog($event)"
>
    <div
        role="dialog"
        class="agpr-dialogContainer"
        [ngClass]="{
            'agpr-dialogContainer-hideRows': hideRows,
            'agpr-dialogContainer--fitContent': fitContent
        }"
        [id]="id"
        [attr.aria-modal]="true"
        [attr.aria-labelledby]="id + '.dialogTitle'"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        [clickOutsideEnabled]="clickOutside"
        (clickOutside)="close.emit()"
    >
        @if (showHeader) {
            <div
                [attr.id]="id ? (id + '_dialogHeader') : null"
                class="agpr-dialogContainer-header"
            >
                <div
                    [id]="id + '.dialogTitle'"
                    ngClass="agpr-dialogContainer-heading"
                >
                    <h2
                        [attr.id]="id ? (id + '_dialogHeading') : null"
                        class="agpr-dialogContainer-heading-text"
                        tabindex="0"
                    >
                        @if (headingIcon) {
                            <span
                                class="agpr-dialogContainer-heading-icon {{ headingIcon }}"
                                aria-hidden="true"
                            ></span>
                        }
                        @if (showLoadingHeader) {
                            <span
                                class="agpr-dialogContainer-loadingHeader"
                                [agprLoading]="true"
                                [agprInlineLoadingIndicator]="true"
                                [loadingSmallIndicator]="true"
                            ></span>
                        }
                        {{ heading | localize }}
                    </h2>
                </div>
                <div
                    [attr.id]="id ? (id + '_dialogActions') : null"
                    class="agpr-dialogContainer-actions"
                >
                    @if (showClose) {
                        <button
                            [id]="id + '.close'"
                            class="agpr-dialogContainer-close"
                            aria-label="close"
                            (click)="close.emit()"
                        >
                            <span
                                [attr.id]="id ? (id + '_dialogCloseIcon') : null"
                                class="fa-regular fa-duotone fa-xmark"
                                aria-hidden="true"
                            ></span>
                        </button>
                    }
                </div>
            </div>
        }
        <div
            [attr.id]="id ? (id + '_dialogContent') : null"
            class="agpr-dialogContainer-content"
            [class.agpr-dialogContainer-content--padded]="contentPadding"
            [class.agpr-dialogContainer-content--noMargin]="noMargin"
        >
            <ng-content></ng-content>
        </div>
        @if (!hideFooter) {
            <div
                [attr.id]="id ? (id + '_dialogFooter') : null"
                class="agpr-dialogContainer-footer"
            >
                <div
                    [attr.id]="id ? (id + '_dialogFooterLeft') : null"
                    class="agpr-dialogContainer-footerLeft"
                >
                    <ng-container *ngTemplateOutlet="footerLeft"></ng-container>
                </div>
                <div
                    [attr.id]="id ? (id + '_dialogFooterContent') : null"
                    class="agpr-dialogContainer-footerContent"
                >
                    <ng-container *ngTemplateOutlet="footer"></ng-container>
                </div>
                <div
                    [attr.id]="id ? (id + '_dialogFooterRight') : null"
                    class="agpr-dialogContainer-footerRight"
                >
                    <ng-container *ngTemplateOutlet="footerRight"></ng-container>
                </div>
            </div>
        }
    </div>
</div>
